module.exports = __webpack_public_path__ + "static/media/icons.f327cbe5.svg";